<ng-container *ngIf="_loading">
    <div class="loading-body"></div>
    <div class="loading">
        <span class="loader"></span>
    </div>
  </ng-container>
  